import '../styles/app.css';
import '../styles/globals.scss';

import { GoogleTagManager } from '@next/third-parties/google';
import { OpenPanelComponent } from '@openpanel/nextjs';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { Nunito_Sans } from 'next/font/google';
import type { NextPage } from 'next';
import type { ReactElement } from 'react';

import Layout from '../components/Layout';
import {
	isOpenPanelEnabled,
	OPENPANEL_PROXY_PATH,
	OPENPANEL_PROXY_SCRIPT_URL,
	openpanelClientId,
} from '../lib/openpanel';

const nunito = Nunito_Sans({
	subsets: ['latin'],
});

type NextPageWithLayout = NextPage & {
	getLayout?: (page: ReactElement) => ReactElement;
};

type AppPropsWithLayout = AppProps & {
	Component: NextPageWithLayout;
};

function MyApp({ Component, pageProps }: AppPropsWithLayout) {
	const getLayout = Component.getLayout
		? (page: ReactElement) => page
		: (page: ReactElement) => <Layout>{page}</Layout>;

	return (
		<>
			<Head>
				<title>ECO Pralnia Fast and Clean</title>
			</Head>

			{isOpenPanelEnabled ? (
				<OpenPanelComponent
					clientId={openpanelClientId}
					apiUrl={OPENPANEL_PROXY_PATH}
					scriptUrl={OPENPANEL_PROXY_SCRIPT_URL}
					trackScreenViews
					trackOutgoingLinks
				/>
			) : null}

			<main className={nunito.className}>
				{getLayout(<Component {...pageProps} />)}
			</main>
			<GoogleTagManager gtmId="GTM-TZ7FV86K" />
		</>
	);
}

export default MyApp;
